import {Box, Button, Modal, Paper, Stack, styled, TextField, Typography} from "@mui/material";
import {LoadingButton} from "../../../theme/components/LoadingButton";
import {useState} from "react";
import Toasty from "../../../theme/components/Toasty";

const InputFieldModal = (props) => {

    const {title, inputProps, onClose, onConfirm, pending, options = {}, ...restProps} = props;
    const { clearAfter } = options;

    const [inputValue, setInputValue] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!inputValue) return Toasty.error('لطفا فیلد خواسته شده را تکمیل کنید');
        onConfirm && onConfirm(inputValue);
        if (clearAfter) setInputValue('');
    }

    return (
        <StyledModal onClose={onClose} {...restProps}>
            <Paper elevation={25} sx={{ width: {xs: "90%", lg: "auto" }, minWidth: { lg: "25%" }, maxWidth: {xs: "90%", lg: "85%", xl: "75%", xxl: "65%"}, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto" }}>
                <Typography textAlign="center" fontWeight={500}>{title}</Typography>
                <Stack mt={3} component="form" onSubmit={handleSubmit} spacing={2}>
                    <TextField value={inputValue} onChange={(e) => setInputValue(e.target.value)} fullWidth {...inputProps}/>
                    <Box>
                        <LoadingButton
                            loading={pending} type='submit'
                            fullWidth variant="contained"
                            sx={{ py: 1.5 }} disableElevation>ثبت</LoadingButton>
                        <Button onClick={onClose} fullWidth variant="outlined" sx={{ mt: 1.5, py: 1.5 }}>انصراف</Button>
                    </Box>
                </Stack>
            </Paper>
        </StyledModal>
    )
}
export default InputFieldModal;

const StyledModal = styled(Modal)(({theme}) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));